import { render, staticRenderFns } from "./EmployeeCode.vue?vue&type=template&id=3d56c516&scoped=true"
import script from "./EmployeeCode.vue?vue&type=script&lang=js"
export * from "./EmployeeCode.vue?vue&type=script&lang=js"
import style0 from "./EmployeeCode.vue?vue&type=style&index=0&id=3d56c516&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d56c516",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/share/nginx/html/staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d56c516')) {
      api.createRecord('3d56c516', component.options)
    } else {
      api.reload('3d56c516', component.options)
    }
    module.hot.accept("./EmployeeCode.vue?vue&type=template&id=3d56c516&scoped=true", function () {
      api.rerender('3d56c516', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/EmployeeCode.vue"
export default component.exports